import { signInUser } from "../../Utility/Auth";
import AccountsDashboard from "./AccountsDashboard";
import AdminDashboard from "./AdminDashboard";
import EcomDashboard from "./EcomDashboard";
import POSDashboard from "./POSDashboard";
import SupervisorDashboard from "./SupervisorDashboard";

const Dashboard = () => {
  const loggedInUser = signInUser();
  return (
    <>
      {(loggedInUser?.type === "admin" ||
        loggedInUser?.type === "manager" ||
        loggedInUser?.type === "owner") && <AdminDashboard />}
      {loggedInUser?.type === "POS" && <POSDashboard />}
      {loggedInUser?.type === "accounts" && <AccountsDashboard />}
      {loggedInUser?.type === "ecom" && <EcomDashboard />}
      {loggedInUser?.type === "supervisor" && <SupervisorDashboard />}
    </>
  );
};

export default Dashboard;
